import { withTranslation, WithTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import React, { useEffect, useState } from 'react';
import { focusCloseButton, reactModalProps } from '../modal';
import { EAccountType } from '../../../helpers/models/accountModel';

interface IFormDescriptionModal extends WithTranslation {
    name: string;
    type: EAccountType;
}

const FormDescriptionModal = (props: IFormDescriptionModal) => {
    const { t, name, type } = props;
    const [modalIsOpen, setModalIsOpen] = useState(true);

    useEffect(() => {
        if (!modalIsOpen) {
            document.body.classList.remove('modal-open');
        } else {
            focusCloseButton();
        }
    }, [modalIsOpen]);

    ReactModal.setAppElement('#root');
    const title =
        type === EAccountType.ORGANIZATION
            ? t('form_modal_description_title_organization')
            : t('form_modal_description_title_professional');
    return (
        <ReactModal
            aria-label={t('modal_description_container_aria_label', { ns: 'accessibility' })}
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            contentLabel={title}
            {...reactModalProps}
        >
            <button
                className="modal__close-icon"
                onClick={() => setModalIsOpen(false)}
                aria-label={t('modal_close_aria_label', { ns: 'accessibility' })}
                id="modal_close_button"
            >
                <span className="visuallyhidden">
                    {t('modal_close_aria_label', { ns: 'accessibility' })}
                </span>
                <span aria-hidden="true">×</span>
            </button>
            <div className="body-medium">
                <h2 className="header-1 modal-header">{name + title}</h2>
                <div>{t('form_modal_description_description')}</div>
                <br />
                <div>{t('form_modal_description_subtitle')}</div>
                <ul className="modal-bottom-element">
                    <li>{t('form_modal_description_element_1')}</li>
                    <li>{t('form_modal_description_element_2')}</li>
                    <li>{t('form_modal_description_element_3')}</li>
                    <li>{t('form_modal_description_element_4')}</li>
                </ul>
                <div className="modal-center-button-container">
                    <button
                        className="button button--primary modal-center-button"
                        onClick={() => setModalIsOpen(false)}
                    >
                        {t('form_modal_description_continue')}
                    </button>
                </div>
            </div>
        </ReactModal>
    );
};

export default withTranslation()(FormDescriptionModal);
